import React, {Fragment} from 'react';
import {IconButton,Grid, Table, TableHead,TableBody, TableRow, TableCell} from '@material-ui/core';
import {MoreVert} from '@material-ui/icons';
import _ from 'lodash'
import { withStyles } from "@material-ui/core/styles";
import styled from 'styled-components';
import moment from 'moment';
import numeral from 'numeral';
import shortid from 'shortid';
import { connect } from 'formik';
import { connect as reduxConnect } from "react-redux";
import { compose} from "redux";
import AddButton from 'components/Global/Buttons/AddButton';
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
import PrepaymentScheduleModalForm from './PrepaymentScheduleModalForm';
import {exportPrepaymentSchedules} from 'store/state/loan/prepaymentSchedules';
import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
} from '../../FormSectionComponents';
import {
  prepaymentTypes,NONE} from 'constants/prepaymentTypes';
let prepaymentTypeList = prepaymentTypes.map( x=> {
    if(x.value === NONE){
      return {
        name: 'No Penalty',
        value: x.value
      }
    }
    return x;
  })
const PositionedMoreVert = styled(MoreVert)`  
  &&& {    
    fill: #ccc;
  }
  border-radius: 8px;  
  &&:hover {   
    fill: #999; 
    cursor:pointer;    
  }
`
const StyledTableHead = styled(TableHead)`
  && {
    border-bottom: 3px solid #eee;
  }
`
const PrepaymentScheduleTableWrapper = styled(Grid)`
  &&& {
    max-width: 1270px;
    padding-right:20px;
  }
`
const AddPrepaymentScheduleButton = styled(AddButton)`
  &&& {
    margin-left:0;
    margin-top:8px;
  }
`
const HeaderCell = styled(TableCell)`
  &&& {
    color:#202020;    
    font-size:17px;  
  }
`
const OptionsCell = styled(TableCell)`
  &&& {
    display:flex;
    justify-content: flex-end;
    margin-bottom: -1px;
  }
`
const RowOptionsCell = styled(OptionsCell)`
  &&&& {
    height:48px;
    align-items:center;
  }
`
const EmptyPrepaymentSchedules = styled.div`
  padding:12px;  
  align-self:stretch;
  background:#f2f2f2;
  color:#999999;
`
const styles = theme => ({
  headerRow: {
    background: '#f9f9f9',
    height:'40px'
  },
  startCell: {
    padding: '8px'
  },
  endCell: {
    padding: '8px'
  },
  iconButton: {   
      maxHeight:'40px', 
      '&:hover': {
        background: 'none'
      }
  }
});

class PrepaymentSchedule extends React.Component {  
  state ={
    isModalOpen:false,
    isDeleteDialogOpen: false,    
    prepaymentScheduleIdToRemove: null,
    currentlyAddingId: '',
    currentIndex: 0,
    isAddingPrepaymentSchedule:false,
    oldVersion: null,
  }
  options = [
    { id: 0, value: "Edit", onClick: (optionId, row) => { this.editPrepaymentSchedule(row.id);} },
    { id: 1, value: "Delete", onClick: (optionId, row) => { this.confirmRemove(row.id);} },
  ]
  headerOptions = [
    {id: 1, value: 'Export', onClick: (optionId) => { 
      const loanId = this.props.loanId;            
      this.props.exportPrepaymentSchedules({id: loanId, isQuote: this.props.isQuote});      
      }
    }
  ]

  addPrepaymentSchedule = () => {
    const {formik} = this.props;
    const prepaymentSchedules = this._getPrepaymentSchedules();
    const newPrepaymentSchedules = [...prepaymentSchedules];
    let newid = 'fakenew'+shortid();
    newPrepaymentSchedules.push({
      id: newid,
      prepaymentTypeId: '',
      openPeriod: '',
      percent: '',
      aggregateInterestMethodId: '',
      aggregateInterestDefinedAmt: '',
      aggregateInterestMonthsOfInterest:'',
      description: '',
      begin: null,
      end: null,
    });
    formik.setFieldValue('prepaymentSchedules', newPrepaymentSchedules);
    this.setState({
      currentlyAddingId: newid,
      currentIndex: newPrepaymentSchedules.length -1,
      isModalOpen: true,
      isAddingPrepaymentSchedule:true            
    })
  }
  editPrepaymentSchedule = (id) => {
    const prepaymentSchedules = this._getPrepaymentSchedules();
    let index = _.findIndex(prepaymentSchedules, function(o) {
      return o.id == id;
    });
    this.setState({
      oldVersion: {...prepaymentSchedules[index]},
      currentIndex:index,
      isModalOpen:true,
      isAddingPrepaymentSchedule:false
    })
  }  
  onClose = () => {
    if(this.state.isAddingPrepaymentSchedule){
      this.remove(this.state.currentlyAddingId); //new prepayment schedules will have an id set to fakenew+shortid
    } else {
      this.restoreOldVersion();
    }
    this.setState({
      isModalOpen:false,
      currentlyAddingId: '',
      oldVersion: null
    });
  }  
  restoreOldVersion = () => {
    const {oldVersion, currentIndex} = this.state;
    const prepaymentSchedules = this._getPrepaymentSchedules();
    prepaymentSchedules[currentIndex] = oldVersion;
  }
  onEditPrepaymentSchedule = () => {    
    this.setState({
      isModalOpen:false
    })
  }
  mapPrepaymentSchedules = (prepaymentSchedules) => {
    return prepaymentSchedules.map(x => {
      let startDate = _.get(x, 'begin', '');
      let endDate = _.get(x, 'end', '');
      let term = _.get(x, "term");
      let prepaymentType = this.findPrepaymentType(x);        
      if(startDate){
        startDate = moment(startDate).format('LL');
      }
      if(endDate){
        endDate = moment(endDate).format('LL');
      }      
      return {
        id: _.get(x, 'id'),
        prepaymentType:  prepaymentType,
        startDate: startDate,
        endDate: endDate,
        term,
        description: _.get(x, 'description','')
      }
    });   
  }
  findPrepaymentType = prepaymentSchedule => {
    if(!prepaymentSchedule.prepaymentTypeId)
      return '';
    return _.find(prepaymentTypeList, x => x.value === prepaymentSchedule.prepaymentTypeId).name;
  }
  _getPrepaymentSchedules = () => {
    const {formik} = this.props
    const {values} = formik;
    const {prepaymentSchedules} = values;
    return prepaymentSchedules;
  }
  remove = (prepaymentScheduleId) => {
    const {formik} = this.props;
    const prepaymentSchedules = this._getPrepaymentSchedules();
    let newPrepaymentSchedules = [...prepaymentSchedules];
    let index = _.findIndex(newPrepaymentSchedules, function(o) {
      return o.id == prepaymentScheduleId;
    });
    if(index != -1){
      newPrepaymentSchedules.splice(index, 1);
    }
    formik.setFieldValue('prepaymentSchedules', newPrepaymentSchedules);
    this.setState({
      isDeleteDialogOpen:false,
    });
  }
  cancelDeletePrepaymentSchedule = () => {
    this.setState({
      isDeleteDialogOpen:false,
      prepaymentScheduleIdToRemove: null
    });
  }

  openOptionsMenu = (row) => {
    this.setState({
      isOptionsMenuOpen: true
    })
  }
  confirmRemove = (id) => {
    this.setState({
      isDeleteDialogOpen: true,
      prepaymentScheduleIdToRemove: id
    })
  }
  buttonRenderer = (isMenuOpen, clickHandler) => {
    const { classes} = this.props;
    return (
      <IconButton classes={{root: classes.iconButton}}>
        <PositionedMoreVert 
          onClick={clickHandler}/>
      </IconButton>
    )
  }
  createRow = (row) => {
    const {isEditing,classes,isQuote} = this.props;
    return (
      <TableRow key={row.id}>
        <TableCell classes={{root: classes.startCell}}>{row.prepaymentType}</TableCell>
        {!isQuote && <>
          <TableCell >{row.startDate}</TableCell>
          <TableCell >{row.endDate}</TableCell>  
        </>}
        {isQuote && 
          <TableCell>{row.term ? `${row.term} Months` : "-"}</TableCell>
        }             
        {!isEditing && <TableCell colSpan={2}>{row.description}</TableCell>}
        {isEditing && <TableCell >{row.description}</TableCell>}        
        {isEditing && <RowOptionsCell>
          <OptionsMenu 
            row={row} 
            buttonRenderer={this.buttonRenderer}
            options={this.options}/>  
          </RowOptionsCell>}        
      </TableRow>
    )
  }

  render(){    
    const {isEditing,formik, classes, isQuote} = this.props;    
    const {values} = formik;
    const prepaymentSchedules = _.get(values, 'prepaymentSchedules',[]);
    const mappedPrepaymentSchedules = this.mapPrepaymentSchedules(prepaymentSchedules);    
    const hasPrepaymentSchedules = mappedPrepaymentSchedules.length > 0;
    const {isModalOpen,prepaymentScheduleIdToRemove,isAddingPrepaymentSchedule,isDeleteDialogOpen, currentIndex} = this.state;    
    return (
      <Fragment>        
        <ChildSectionTitle>Prepayment Schedule</ChildSectionTitle>
        <PrepaymentScheduleTableWrapper container alignItems="flex-start" direction="column">
          {hasPrepaymentSchedules && <Table padding='none'>
            <StyledTableHead>
              <TableRow classes={{root:classes.headerRow}}>
                <HeaderCell classes={{root: classes.startCell}}>Prepayment Type</HeaderCell>
                {!isQuote && <>
                  <HeaderCell >Start Date</HeaderCell>
                  <HeaderCell >End Date</HeaderCell>
                </>}
                {isQuote && 
                <HeaderCell>Term</HeaderCell>
                }    
                <HeaderCell >Description</HeaderCell>            
                <OptionsCell>
                  <OptionsMenu                      
                    buttonRenderer={this.buttonRenderer}                 
                    options={this.headerOptions}/>  
                </OptionsCell>                
              </TableRow>
            </StyledTableHead>
            <TableBody>
              {mappedPrepaymentSchedules.map(row => this.createRow(row))}
            </TableBody>
          </Table>}
          {!hasPrepaymentSchedules && <EmptyPrepaymentSchedules>There are no prepayments</EmptyPrepaymentSchedules>}
          {isEditing && 
          <AddPrepaymentScheduleButton id="addPrepaymentScheduleButton" onClick={this.addPrepaymentSchedule} title="Add Prepayment Schedule"/>}
          <PrepaymentScheduleModalForm 
            isQuote = {this.props.isQuote}
            onCancel={this.onClose}
            onClose={this.onClose}
            index={currentIndex}                 
            onEdit={this.onEditPrepaymentSchedule}
            isAdding={isAddingPrepaymentSchedule}
            isOpen={isModalOpen}/>
          </PrepaymentScheduleTableWrapper>
          <SimpleConfirmDialog
            title="Confirm Delete"
            message="You are about to delete this prepayment. Are you sure you want to do this?"
            modalOpen={isDeleteDialogOpen}
            handleNo={this.cancelDeletePrepaymentSchedule}
            handleYes={() => this.remove(prepaymentScheduleIdToRemove)}
            noText="No"
            yesText="Yes, Delete"
           />        
      </Fragment>
  )};
}

const mapStateToProps = ({  }) => ({
});

export default compose(
  connect,
  reduxConnect(
    mapStateToProps,
    {
      exportPrepaymentSchedules 
    }
  ),
  withStyles(styles),
)(PrepaymentSchedule);